import BaseService from 'services/BaseService';

//-------------------------------------------------------------------------------------------------------------------

export default class ImportedBookingService
    extends BaseService {

    static async getGrimsbyBookingEmails() {
        return BaseService.callAPI('email/get-grimsby-booking-emails');
    }

    static async listPending() {
        return BaseService.callAPI('imported-booking/list-pending');
    }

    static async ignore(id) {
        return BaseService.callAPI('imported-booking/ignore/' + id);
    }

    static async getFullInfo(id) {
        return BaseService.callAPI('imported-booking/get-full-info/' + id);
    }
}
